import PropTypes from 'prop-types';
import React from 'react';
import InputTypes from '../../../../common/components/InputTypes';
import { SelectBox } from '../../../../common/components/SelectBox';

const CardDetails = ({
    inputRefs,
    errors,
    cardTypesArray,
    paymentType,
    handleTypeChange,
    nameOnCard,
    handleNameChange,
    handleBlur,
    showCardType
}) => {
    const signleInput = showCardType ? 'p-card' : 'p-card p-card--single';

    return (
        <div className="card-number-types flex-column-s flex-row-top-justify-m flex-row-top-justify-l">
            <div className={signleInput}>
                <InputTypes
                    inputRef={inputRefs['payment[name_on_card]']}
                    type="text"
                    name="payment[name_on_card]"
                    label="Name on card"
                    placeHolder="Name on card"
                    onChange={handleNameChange}
                    isRequired={true}
                    value={nameOnCard}
                    className="cardName"
                    onBlur={handleBlur}
                    error={errors['payment[name_on_card]']}
                    autocomplete="cc-name"
                />
            </div>
            {showCardType && (
                <div className="p-card">
                    <SelectBox
                        inputRef={inputRefs['payment[type]']}
                        name="payment[type]"
                        options={cardTypesArray}
                        value={paymentType}
                        valueIndex={0}
                        onChange={handleTypeChange}
                        placeholder="Select card type"
                        isRequired={true}
                        error={errors['payment[type]']}
                        showErrorMessage={true}
                        label="Card type"
                        autocomplete="cc-type"
                    />
                </div>
            )}
        </div>
    );
};

CardDetails.propTypes = {
    inputRefs: PropTypes.objectOf(PropTypes.func),
    errors: PropTypes.objectOf(PropTypes.string),
    cardTypesArray: PropTypes.array,
    handleTypeChange: PropTypes.func,
    paymentType: PropTypes.string,
    handleNameChange: PropTypes.func,
    nameOnCard: PropTypes.string,
    handleBlur: PropTypes.func,
    showCardType: PropTypes.bool
};

CardDetails.defaultProps = {
    inputRefs: {},
    errors: {},
    cardTypesArray: [],
    handleTypeChange: () => {},
    paymentType: '',
    handleNameChange: () => {},
    nameOnCard: '',
    handleBlur: () => {},
    showCardType: false
};

export default CardDetails;
